import {action, observable} from 'mobx';
import {auth, types, endpoints} from 'main/tools';
import {DomainStore} from 'shared/store';
import EmployeeDetails from 'stores/employees/EmployeeDetails';
import {redirect} from 'shared/tools';

class OnboardEmergencyState {
  store = new DomainStore();

  @observable employee;
  @observable errors = {};

  @action async load() {
    await this.store._compose([
      endpoints.EMPLOYEE_DETAILS.with(auth.employee.id)
    ]);

    this.employee = new EmployeeDetails(
      this.store._getSingle(types.EMPLOYEE_DETAILS, {id: auth.employee.id})
    );
  }

  @action async nextStep() {
    const {model, errors} = await this.store.patch(
      endpoints.EMPLOYEE_ONBOARD.EMERGENCY_INFO.with(auth.employee.id),
      types.EMPLOYEE_DETAILS,
      this.employee
    );
    this.errors = errors;

    if (model) {
      return redirect('/onboard');
    }
  }
}

export default OnboardEmergencyState;
